<template>
  <PreviewLayout :item="item" :loading="loading">
    <div class="p-postEditor__point">
      <div class="p-postEditor__point__block">
        <p class="p-postEditor__point__heading">POINT</p>
        <p class="p-postEditor__point__title" v-html="previewTitleItem()"></p>
        <p class="p-postEditor__point__desc" v-html="previewContentItem()"></p>
      </div>
    </div>
  </PreviewLayout>
</template>

<script>
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import PreviewLayout from './PreviewLayout'

export default {
  name: 'PointItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      titleLintTag: this.textLintAllowTagFormat('title'),
      contentLintTag: this.textLintAllowTagFormat('content')
    }
  },
  computed: {
    title: function () {
      return this.item.itemableAttributes.title
    },
    content: function () {
      return this.item.itemableAttributes.content
    },
    lintContent: function () {
      return `${this.titleLintTag[0]}${this.title}${this.titleLintTag[1]}\n${this.contentLintTag[0]}${this.content}${this.contentLintTag[1]}`
    }
  },
  mounted () {
    this.setLintAction(this.lintContent)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.lintContent)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  },
  methods: {
    previewTitleItem () {
      return this.parseLintContent(this.titleLintTag) || this.title
    },
    previewContentItem () {
      return this.parseLintContent(this.contentLintTag) || this.content
    },
    parseLintContent (tag) {
      const previewContentText = this.previewContent(this.lintContent)
      const re = new RegExp(`${tag[0]}[\\s\\S]*${tag[1]}`, 'g')

      if (previewContentText.match(re)) {
        return previewContentText
          .match(re)
          .pop()
          .replace(tag[0], '')
          .replace(tag[1], '')
      }
    }
  }
}
</script>

<style scoped lang="sass">
.p-postEditor__point__desc
  white-space: pre-line
  word-wrap: break-word
</style>
